module.exports = __webpack_public_path__ + "static/media/spinning-ball.54154f11.gif";